"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const immer_1 = require("immer");
const calculateLocalBatchItem_1 = __importDefault(require("./calculateLocalBatchItem"));
const fixPrecision_1 = __importStar(require("./fixPrecision"));
const getRoundNumber_1 = __importDefault(require("./getRoundNumber"));
const libConfig_1 = __importDefault(require("./libConfig"));
const sortOrderModifiers_1 = require("./sortOrderModifiers");
const addNumberWithRounding_1 = __importDefault(require("./addNumberWithRounding"));
const getDisplayStatusKey_1 = __importDefault(require("./getDisplayStatusKey"));
const calculateLocalOrderTax_1 = __importDefault(require("./calculateLocalOrderTax"));
const calculateOrderSurcharge_1 = __importDefault(require("./calculateOrderSurcharge"));
const precisionMath_1 = require("./precisionMath");
const round_1 = __importDefault(require("./round"));
function calculateLocalOrder(appOrder, showReport = false) {
    return (0, immer_1.produce)(appOrder, order => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        // ======================== 計算 item level ========================
        // 餐點原價
        let productsOriginalTotal = 0;
        // 餐點小計 (餐點原價加總不含 DISCOUNT 折扣，但會含 COMBORULE, MERCHANT)
        let productsSubtotal = 0;
        // 餐點總價 (經過折扣) = itemSubtotal - itemDiscount
        let productsTotal = 0;
        // 項目折扣 (只包含 DISCOUNT 折扣)
        let productDiscountModifiersDiscount = 0;
        // 項目折扣 (只包含 COMBORULE 撞餐和 MERCHANT 改價)
        let productMerchantModifiersDiscount = 0;
        const reports = {
            originalTotal: [],
            itemLevelDiscount: [],
            total: [],
            totalWithoutDiscountModifiers: [],
            surchargeableItems: [],
            discountableItems: [], // 可以計算折扣的餐點: 餐點不含 DISOUNT 的 total excludeOrderDiscount
        };
        if (showReport) {
            console.log('——————————————— item level ———————————————');
        }
        let itemIndex = 0;
        order.batches = lodash_1.default.map(order.batches, batch => {
            const calculatedItems = batch.items.map(item => (0, calculateLocalBatchItem_1.default)(item, order));
            if (['submitted', 'confirmed'].includes(batch.status)) {
                // 只計算 submitted, confirmed 的 batch
                productsOriginalTotal += lodash_1.default.sumBy(calculatedItems, 'originalTotal');
                productDiscountModifiersDiscount += lodash_1.default.sumBy(calculatedItems, 'totalDiscountModifiersDiscount');
                productMerchantModifiersDiscount += lodash_1.default.sumBy(calculatedItems, 'totalMerchantModifiersDiscount');
                productsSubtotal += lodash_1.default.sumBy(calculatedItems, 'totalWithoutDiscountModifiers');
                productsTotal += lodash_1.default.sumBy(calculatedItems, 'total');
                if (showReport) {
                    calculatedItems.forEach(item => {
                        var _a, _b, _c, _d, _e, _f, _g;
                        console.log(`————————————————— items[${itemIndex++}] —————————————————`);
                        console.log(`${item.name}${item.isSet ? '(套餐)' : ''}`);
                        console.log(`數量: ${item.quantity}\t原價: ${item.originalTotal}`);
                        const modifierNames = {
                            DISCOUNT: '折扣',
                            MERCHANT: '改價 (非折扣)',
                            COMBORULE: '撞餐 (非折扣)',
                            SURCHARGE: '服務費',
                            SHIPPING_DISCOUNT: '運費折扣',
                            PROMOCODE: '優惠碼',
                            RICECOIN: 'RiceCoin',
                        };
                        item.modifiers.forEach((modifier, index) => {
                            console.log(`————— modifiers[${index}] —————`);
                            console.log(`${modifierNames[modifier.type]} (${modifier.type})`);
                            console.log(`內容: ${modifier.amount !== 0 ? modifier.amount : modifier.percent}`, `計算金額: ${(0, fixPrecision_1.default)(modifier.calculatedAmount)}`);
                        });
                        console.log('———————————————');
                        console.log(`總折扣: ${(_a = item.totalDiscountModifiersDiscount) !== null && _a !== void 0 ? _a : 0}`);
                        console.log(`total: ${item.total}`);
                        reports.originalTotal.push(item.originalTotal);
                        reports.itemLevelDiscount.push((_b = item.totalDiscountModifiersDiscount) !== null && _b !== void 0 ? _b : 0);
                        reports.total.push(item.total);
                        reports.totalWithoutDiscountModifiers.push((_c = item.totalWithoutDiscountModifiers) !== null && _c !== void 0 ? _c : 0);
                        if (item.isSet) {
                            const surchargeableSetItems = [];
                            const discountableSetItems = [];
                            // 套餐殼
                            surchargeableSetItems.push(item.excludedOrderSurcharge ? 0 : ((_d = item.totalWithoutSetItemsWithoutDiscountModifiers) !== null && _d !== void 0 ? _d : 0));
                            discountableSetItems.push(item.excludeOrderDiscount ? 0 : ((_e = item.totalWithoutSetItemsWithoutDiscountModifiers) !== null && _e !== void 0 ? _e : 0));
                            item.setItems.forEach(setItem => {
                                var _a, _b;
                                surchargeableSetItems.push(setItem.excludedOrderSurcharge ? 0 : ((_a = setItem.totalWithoutDiscountModifiers) !== null && _a !== void 0 ? _a : 0));
                                discountableSetItems.push(setItem.excludeOrderDiscount ? 0 : ((_b = setItem.totalWithoutDiscountModifiers) !== null && _b !== void 0 ? _b : 0));
                            });
                            reports.surchargeableItems.push(surchargeableSetItems);
                            reports.discountableItems.push(discountableSetItems);
                        }
                        else {
                            reports.surchargeableItems.push(item.excludedOrderSurcharge ? 0 : ((_f = item.totalWithoutDiscountModifiers) !== null && _f !== void 0 ? _f : 0));
                            reports.discountableItems.push(item.excludeOrderDiscount ? 0 : ((_g = item.totalWithoutDiscountModifiers) !== null && _g !== void 0 ? _g : 0));
                        }
                    });
                }
            }
            return Object.assign(Object.assign({}, batch), { items: calculatedItems });
        });
        if (showReport) {
            console.log('——————————————— order level ———————————————');
            console.log(`原價 = ${reports.originalTotal.join(' + ')} = ${productsOriginalTotal}`);
            console.log(`item level 折扣 = ${reports.itemLevelDiscount.join(' + ')} = ${productDiscountModifiersDiscount}`);
            console.log(`餐點 total = ${reports.total.join(' + ')} = ${productsTotal}`);
            console.log(`餐點不含 DISOUNT 的 total = ${reports.totalWithoutDiscountModifiers.join(' + ')} = ${productsSubtotal}`);
            const surchargeableItemsArray = [];
            let surchargeableItemsTotal = 0;
            const discountableItemsArray = [];
            let discountableItemsTotal = 0;
            reports.surchargeableItems.forEach((item) => {
                if (typeof item !== 'number') {
                    surchargeableItemsArray.push(`(${item.join(' + ')})`);
                    surchargeableItemsTotal += lodash_1.default.sum(item);
                }
                else {
                    surchargeableItemsArray.push(item);
                    surchargeableItemsTotal += item;
                }
            });
            reports.discountableItems.forEach((item) => {
                if (typeof item !== 'number') {
                    discountableItemsArray.push(`(${item.join(' + ')})`);
                    discountableItemsTotal += lodash_1.default.sum(item);
                }
                else {
                    discountableItemsArray.push(item);
                    discountableItemsTotal += item;
                }
            });
            console.log(`可以計算服務費的餐點 = ${surchargeableItemsArray.join(' + ')} = ${surchargeableItemsTotal}`);
            console.log(`可以計算折扣的餐點 = ${discountableItemsArray.join(' + ')} = ${discountableItemsTotal}`);
        }
        // ======================== 計算 order level ========================
        // * 計算運費
        let shippingFeeBaseTotal = 0; // 可用來計算 shipping modifier 的運費 (不含小額服務費)
        let smallOrderFee = 0; // 小額服務費
        if (order.shipping != null && order.deliveryType === 'storeDelivery') {
            shippingFeeBaseTotal = (0, precisionMath_1.add)((0, precisionMath_1.add)(((_a = order.shipping.baseShippingFee) !== null && _a !== void 0 ? _a : 0), ((_b = order.shipping.tunnelFee) !== null && _b !== void 0 ? _b : 0)), ((_c = order.shipping.longDistanceFee) !== null && _c !== void 0 ? _c : 0));
            smallOrderFee = (_d = order.shipping.smallOrderFee) !== null && _d !== void 0 ? _d : 0;
        }
        // * 計算 modifiers
        // 加總所有可以折扣的 total，用來分攤 amount 折扣，一律使用折扣後的 total，避免折超過餐點金額
        let discountableTotalAcc = 0;
        const prepareItem = (item) => {
            var _a, _b, _c;
            // 以下兩個欄位用來分攤 Order level 的折扣
            // 不論是否設定 isOrderProductModifierBasedOnDiscountedItemTotal ，兩者都要在折扣後計算，避免折扣超過餐點金額
            // reset 用來分攤 order level 折扣的 total (不含折扣版)
            item.totalWithoutSetItemsWithoutItemDiscountAfterOrderDiscount = (_a = item.totalWithoutSetItemsWithoutDiscountModifiers) !== null && _a !== void 0 ? _a : 0;
            // reset 用來分攤 order level 折扣的 total (含折扣版)
            item.totalWithoutSetItemsAfterOrderDiscount = (_b = item.totalWithoutSetItems) !== null && _b !== void 0 ? _b : 0;
            if (!item.excludeOrderDiscount) {
                discountableTotalAcc = (0, precisionMath_1.add)(discountableTotalAcc, (_c = item.totalWithoutSetItems) !== null && _c !== void 0 ? _c : 0);
            }
        };
        lodash_1.default.forEach(order.batches, (batch) => {
            // 只計算有效的 batch
            if (['submitted', 'confirmed'].includes(batch.status)) {
                lodash_1.default.forEach(batch.items, item => {
                    prepareItem(item);
                    lodash_1.default.forEach(item.setItems, setItem => {
                        prepareItem(setItem);
                    });
                });
            }
        });
        // 算出不可折扣的部分，當 order modifier 有設定 overrideItem 時會用到
        const nonDiscountableTotalAcc = (0, precisionMath_1.subtract)(productsTotal, discountableTotalAcc);
        // 可以用來算 SHIPPING 折扣的 shippingFee
        let shippingFeeAcc = shippingFeeBaseTotal;
        // 可以用來算 ALL 折扣的 total，計算服務費之後還要再加上服務費
        // FIXME: 這裡的 allAcc 需要考慮到服務費的計算
        let allAcc = (0, precisionMath_1.add)((0, precisionMath_1.add)(productsTotal, shippingFeeBaseTotal), smallOrderFee);
        const surchargeModifier = (_e = order.modifiers) === null || _e === void 0 ? void 0 : _e.find(modifier => modifier.type === 'SURCHARGE');
        order.modifiers = (0, sortOrderModifiers_1.sortOrderModifiers)((_f = order.modifiers) !== null && _f !== void 0 ? _f : [])
            .filter(modifier => modifier.type !== 'SURCHARGE')
            .map(modifier => {
            if (modifier.deletedAt != null) {
                // * 被刪除的 modifier 不做計算
                return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
            }
            if (modifier.type === 'RICECOIN' && order.deliveryType === 'table') {
                // * 堂食不可用 RiceCoin
                return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
            }
            if ((modifier.percent > 0 || modifier.amount > 0)) {
                // * 不可加價
                return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
            }
            switch (modifier.applyTo) {
                case 'SHIPPING': {
                    // * 計算運費折扣 (運費折扣不可折到 smallOrderFee)
                    if (order.deliveryType !== 'storeDelivery') {
                        // * 非外送訂單不折扣運費
                        return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
                    }
                    // 折扣後金額 (不可低於 0)
                    const totalWithModifier = Math.max(0, (0, precisionMath_1.add)((0, precisionMath_1.multiply)(shippingFeeAcc, (0, precisionMath_1.divide)((0, precisionMath_1.add)(100, modifier.percent), 100)), modifier.amount));
                    // 折扣金額 (不可大於 shippingFeeAcc)
                    let discountValue = Math.min(shippingFeeAcc, (0, precisionMath_1.subtract)(shippingFeeAcc, totalWithModifier));
                    // 折扣金額不可 < 0
                    discountValue = Math.max(0, discountValue);
                    if (order.enableIntermediateRounding) {
                        discountValue = (0, round_1.default)(discountValue, order.rounding.type, order.rounding.digits);
                    }
                    // 從運費折扣總計扣除
                    shippingFeeAcc = (0, precisionMath_1.subtract)(shippingFeeAcc, discountValue);
                    // 從全單用折扣的總計扣除
                    allAcc = (0, precisionMath_1.subtract)(allAcc, discountValue);
                    // 寫入 modifier 中
                    return Object.assign(Object.assign({}, modifier), { calculatedAmount: -discountValue });
                }
                case 'PRODUCT': {
                    // 總計折扣金額，正數為折扣
                    let totalDiscountValueAcc = 0;
                    const modifierItem = (item) => {
                        var _a, _b;
                        if (item.excludeOrderDiscount && !modifier.overrideItem) {
                            return;
                        }
                        let itemTotal = (_a = item.totalWithoutSetItemsAfterOrderDiscount) !== null && _a !== void 0 ? _a : 0;
                        let itemTotalWithoutItemDiscount = (_b = item.totalWithoutSetItemsWithoutItemDiscountAfterOrderDiscount) !== null && _b !== void 0 ? _b : 0;
                        const totalForCalculation = order.isOrderProductModifierBasedOnDiscountedItemTotal === true
                            ? itemTotal
                            : itemTotalWithoutItemDiscount;
                        let itemDiscountValue = 0; // 這個 item 因當前 modifier 產生的總折扣金額
                        // 處理百分比折扣
                        if (modifier.percent !== 0) {
                            // 折扣多少錢
                            const estDiscountAmount = Math.max(0, (0, precisionMath_1.multiply)(totalForCalculation, (0, precisionMath_1.divide)(-modifier.percent, 100)));
                            // ? pm1332 logic
                            const discountAmount = Math.min(estDiscountAmount, totalForCalculation);
                            itemTotal = (0, precisionMath_1.subtract)(itemTotal, discountAmount);
                            // ? th logic
                            // const discountAmount = Math.min(estDiscountAmount, itemTotal)
                            // itemTotal = Math.max(0, subtract(itemTotal, discountAmount))
                            itemTotalWithoutItemDiscount = Math.max(0, (0, precisionMath_1.subtract)(itemTotalWithoutItemDiscount, discountAmount));
                            itemDiscountValue = (0, precisionMath_1.add)(itemDiscountValue, discountAmount);
                        }
                        // 處理固定金額折扣 (Amount Discount)
                        if (modifier.amount !== 0) {
                            const denominatorForAmount = modifier.overrideItem
                                ? (0, precisionMath_1.add)(discountableTotalAcc, nonDiscountableTotalAcc)
                                : discountableTotalAcc;
                            if (denominatorForAmount > 0) { // 避免除以零
                                // modifier.amount 是總折扣金額 (負值代表折扣)
                                // 算出折扣多少錢 (正值以便和金額比對)
                                const distributedAmount = (0, precisionMath_1.multiply)(-modifier.amount, (0, precisionMath_1.divide)(itemTotal, denominatorForAmount));
                                const discountAmount = Math.min(distributedAmount, itemTotal);
                                itemTotal = Math.max(0, (0, precisionMath_1.subtract)(itemTotal, discountAmount));
                                itemTotalWithoutItemDiscount = Math.max(0, (0, precisionMath_1.subtract)(itemTotalWithoutItemDiscount, discountAmount));
                                itemDiscountValue = (0, precisionMath_1.add)(itemDiscountValue, discountAmount);
                            }
                        }
                        // 更新 item 的 total
                        item.totalWithoutSetItemsAfterOrderDiscount = itemTotal;
                        item.totalWithoutSetItemsWithoutItemDiscountAfterOrderDiscount = itemTotalWithoutItemDiscount;
                        // 將此 item 的折扣金額累加到全單總折扣
                        totalDiscountValueAcc = (0, precisionMath_1.add)(totalDiscountValueAcc, itemDiscountValue);
                    };
                    if (order.enableIntermediateRounding) {
                        totalDiscountValueAcc = (0, round_1.default)(totalDiscountValueAcc, order.rounding.type, order.rounding.digits);
                    }
                    lodash_1.default.forEach(order.batches, batch => {
                        batch.items.forEach(item => {
                            modifierItem(item);
                            lodash_1.default.forEach(item.setItems, setItem => {
                                modifierItem(setItem);
                            });
                        });
                    });
                    allAcc = (0, precisionMath_1.subtract)(allAcc, totalDiscountValueAcc);
                    return Object.assign(Object.assign({}, modifier), { calculatedAmount: -totalDiscountValueAcc });
                }
                case 'ALL': {
                    // ALL 無視 excludeOrderDiscount 且可以折 shipping.smallOrderFee，全部訂單金額都適用
                    // 折扣後金額 (不可低於 0)
                    const totalWithModifier = Math.max(0, (0, precisionMath_1.add)((0, precisionMath_1.multiply)(allAcc, (0, precisionMath_1.divide)((0, precisionMath_1.add)(100, modifier.percent), 100)), modifier.amount));
                    // 折扣金額 (不可大於 allAcc)
                    let discountValue = Math.min(allAcc, (0, precisionMath_1.subtract)(allAcc, totalWithModifier));
                    // 折扣金額不可 < 0
                    discountValue = Math.max(0, discountValue);
                    if (order.enableIntermediateRounding) {
                        discountValue = (0, round_1.default)(discountValue, order.rounding.type, order.rounding.digits);
                    }
                    // 從全單用總計扣除
                    allAcc = (0, precisionMath_1.subtract)(allAcc, discountValue);
                    // 寫入 modifier 中
                    return Object.assign(Object.assign({}, modifier), { calculatedAmount: -discountValue });
                }
                default:
                    // 其他奇怪的情況，先讓他為 0
                    return Object.assign(Object.assign({}, modifier), { calculatedAmount: 0 });
            }
        });
        // validate order modifier discount 不超過食物item 折後總額
        const discountModifier = (_g = order.modifiers) === null || _g === void 0 ? void 0 : _g.find(modifier => modifier.type === 'DISCOUNT' && modifier.calculatedAmount != null);
        // productsTotal
        if (discountModifier != null && (0, precisionMath_1.multiply)(discountModifier.calculatedAmount, -1) > productsTotal) {
            const adjustedCalculatedAmount = (0, precisionMath_1.multiply)(productsTotal, -1);
            discountModifier.calculatedAmount = adjustedCalculatedAmount;
        }
        // 計算項目的稅，只有項目的稅
        const { nonTaxableTotal: nonTaxableItemTotal } = (0, calculateLocalOrderTax_1.default)(order);
        // 全部折扣總計 = 全部折扣的 calculatedAmount 不含服務費，服務費後面才算
        const modifiersDiscountAmountTotal = lodash_1.default.sumBy(order.modifiers, 'calculatedAmount');
        // 計算服務費
        const { nonTaxableSurcharge = 0, modifier: surchargeModifierResult } = (_h = (0, calculateOrderSurcharge_1.default)(order, surchargeModifier)) !== null && _h !== void 0 ? _h : {};
        const nonTaxableTotal = (0, precisionMath_1.add)(nonTaxableItemTotal, nonTaxableSurcharge);
        if (surchargeModifierResult != null) {
            order.modifiers.push(surchargeModifierResult);
        }
        // 服務費(顯示)
        const surcharge = (_j = surchargeModifierResult === null || surchargeModifierResult === void 0 ? void 0 : surchargeModifierResult.calculatedAmount) !== null && _j !== void 0 ? _j : 0;
        // 運費 = 折扣後運費 + 小額服務費
        const shippingFee = (0, precisionMath_1.add)(shippingFeeAcc, smallOrderFee);
        // 運費原價 = 運費 + 小額服務費
        const originalShippingFee = (0, precisionMath_1.add)(shippingFeeBaseTotal, smallOrderFee);
        // 運費折扣總計 = 運費原價 - 運費折扣後總計
        const discountShippingFee = (0, precisionMath_1.subtract)(originalShippingFee, shippingFee);
        // 全部稅
        const taxTotal = (0, precisionMath_1.add)(lodash_1.default.sumBy(order.taxes, 'tax'), (_l = (_k = order.surchargeTax) === null || _k === void 0 ? void 0 : _k.tax) !== null && _l !== void 0 ? _l : 0);
        // 全部用來收稅的金額總計
        // 補算ALL modifier的calculatedAmount進去taxableTotal
        // eg: 原本100$, ricecoin-50$, 運冀10$ = 100+10-50=60 taxableTotal
        const applyToAllModifierCalculatedTotal = lodash_1.default.sumBy((_m = order.modifiers) === null || _m === void 0 ? void 0 : _m.filter(modifier => modifier.applyTo === 'ALL'), 'calculatedAmount');
        const taxableTotal = (0, precisionMath_1.add)((0, precisionMath_1.add)((0, precisionMath_1.add)(lodash_1.default.sumBy(order.taxes, 'taxableTotal'), (_p = (_o = order.surchargeTax) === null || _o === void 0 ? void 0 : _o.taxableTotal) !== null && _p !== void 0 ? _p : 0), shippingFee), applyToAllModifierCalculatedTotal);
        // 稅前總計
        const totalBeforeTax = (0, precisionMath_1.add)(taxableTotal, nonTaxableTotal);
        // 總計 = 稅前總計 + 稅
        const total = (0, precisionMath_1.add)(totalBeforeTax, taxTotal);
        // 服務費
        order.surchargeTotal = (0, fixPrecision_1.roundToFiveDecimal)(surcharge);
        // 稅
        order.taxTotal = (0, fixPrecision_1.roundToFiveDecimal)(taxTotal);
        order.taxableTotal = (0, fixPrecision_1.roundToFiveDecimal)(taxableTotal);
        order.nonTaxableTotal = (0, fixPrecision_1.roundToFiveDecimal)(nonTaxableTotal);
        order.totalBeforeTax = (0, fixPrecision_1.roundToFiveDecimal)(totalBeforeTax);
        // 運費
        order.shippingFee = (0, fixPrecision_1.roundToFiveDecimal)(shippingFee);
        order.originalShippingFee = (0, fixPrecision_1.roundToFiveDecimal)(originalShippingFee);
        order.discountShippingFee = (0, fixPrecision_1.roundToFiveDecimal)(discountShippingFee);
        // 餐點原價總計
        order.originalTotal = (0, fixPrecision_1.roundToFiveDecimal)((0, precisionMath_1.subtract)(productsOriginalTotal, productMerchantModifiersDiscount));
        // 餐點小計 (餐點原價加總不含折扣)
        order.subtotal = (0, fixPrecision_1.roundToFiveDecimal)(productsSubtotal);
        // 折扣總計
        const arr = [(0, precisionMath_1.subtract)(modifiersDiscountAmountTotal, productDiscountModifiersDiscount), -order.subtotal];
        // FIXME: 無法解釋的邏輯，但舊production行為是這樣
        if (order.deliveryType === 'storeDelivery') {
            arr.pop(); // 外送訂單不Max subtotal
        }
        order.calculatedDiscountTotal = (0, fixPrecision_1.roundToFiveDecimal)(Math.max(...arr));
        // 訂單總計
        order.total = (0, fixPrecision_1.roundToFiveDecimal)(total);
        // 顯示用的訂單總計
        order.roundedTotal = (0, fixPrecision_1.roundToFiveDecimal)(Math.max(0, (0, getRoundNumber_1.default)((0, fixPrecision_1.roundToFiveDecimal)(total), (_q = order.rounding) !== null && _q !== void 0 ? _q : libConfig_1.default.rounding)));
        // total 被 round 後的差價
        order.roundedAmount = (0, fixPrecision_1.roundToFiveDecimal)((0, addNumberWithRounding_1.default)(order.roundedTotal, (0, precisionMath_1.multiply)(order.total, -1)));
        // 顯示用的訂單狀態
        order.displayStatusKey = (0, getDisplayStatusKey_1.default)(order);
        if (showReport) {
            console.log('——————————————— Debugging Variables ———————————————');
            const surcharge = (_s = (_r = order.modifiers) === null || _r === void 0 ? void 0 : _r.find(m => m.id === 'SURCHARGE')) === null || _s === void 0 ? void 0 : _s.calculatedAmount;
            console.log('order', {
                calculatedDiscountTotal: order.calculatedDiscountTotal,
                a: {
                    modifiers: lodash_1.default.map(order.modifiers, o => JSON.stringify(lodash_1.default.pick(o, ['id', 'type', 'calculatedAmount']))),
                    modifiersDiscountAmountTotal,
                    productDiscountModifiersDiscount,
                },
                surcharge,
                total,
                roundedTotal: order.roundedTotal,
                totalBeforeTax,
                taxTotal,
                tax: {
                    item: lodash_1.default.sumBy(order.taxes, 'tax'),
                    surcharge: ((_u = (_t = order.surchargeTax) === null || _t === void 0 ? void 0 : _t.tax) !== null && _u !== void 0 ? _u : 0),
                },
                taxableTotal,
                nonTaxableTotal,
                nonTaxable: {
                    nonTaxableItemTotal,
                    nonTaxableSurcharge,
                },
            });
            console.log('——————————————————————————————————————————————');
        }
        if (order.enableIntermediateRounding) {
            order.total = (0, round_1.default)(order.total, order.rounding.type, order.rounding.digits);
            order.totalBeforeTax = (0, round_1.default)(order.totalBeforeTax, order.rounding.type, order.rounding.digits);
            order.taxTotal = (0, round_1.default)(order.taxTotal, order.rounding.type, order.rounding.digits);
            order.taxableTotal = (0, round_1.default)(order.taxableTotal, order.rounding.type, order.rounding.digits);
            order.nonTaxableTotal = (0, round_1.default)(order.nonTaxableTotal, order.rounding.type, order.rounding.digits);
            order.shippingFee = (0, round_1.default)(order.shippingFee, order.rounding.type, order.rounding.digits);
            order.originalShippingFee = (0, round_1.default)(order.originalShippingFee, order.rounding.type, order.rounding.digits);
            order.discountShippingFee = (0, round_1.default)(order.discountShippingFee, order.rounding.type, order.rounding.digits);
            order.calculatedDiscountTotal = (0, round_1.default)(order.calculatedDiscountTotal, order.rounding.type, order.rounding.digits);
            order.surchargeTotal = (0, round_1.default)(order.surchargeTotal, order.rounding.type, order.rounding.digits);
        }
        return order;
    });
}
exports.default = calculateLocalOrder;
//# sourceMappingURL=calculateLocalOrder.js.map